// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"68d7d92f","555":"835642a6","564":"4f6f4920","787":"d16d0675","975":"a17837b5"}[chunkId] + ".chunk.js";
};